<template>
  <div>
    <!-- 添加培训资料 -->
    <el-dialog title="批量选择课件" :visible.sync="isShow" width="70%" @submit.native.prevent>
      <el-form ref="resourceForm" :model="dataForm" label-width="80px">
        <el-row>
          <el-col :span="6">
            <el-form-item label="课件名称" prop="dataName" >
              <el-input
                v-model="dataForm.dataName"
                @keyup.enter.native="search"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="行业类型" prop="professionalCategory">
              <el-select
                placeholder="请选择"
                v-model="dataForm.professionalCategory"
                clearable
                @clear="dataForm.professionalCategory = undefined"
              >
                <el-option
                  v-for="item in categoryList"
                  :key="item.id"
                  :label="item.text"
                  :value="item.code"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6" class="pr20">
            <el-form-item label="课程目录" prop="directoryId">
              <selectTree
                clearable
                :props="{
                  value: 'id', // ID字段名
                  label: 'directoryName', // 显示名称
                  children: 'directoryList' // 子级字段名
                }"
                :options="catalogList"
                :value="dataForm.directoryId"
                @getValue="selectTreeChange"
              ></selectTree>
            </el-form-item>
          </el-col>


          <el-col :span="6">
            <el-form-item>
              <el-button type="primary" @click="search">搜索</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <!-- 课件列表 -->
      <div v-loading="tableLoading" element-loading-text="拼命加载中" >
        <el-table :data="dataList" @selection-change="selectionChange" :row-key="getRowKeys" ref="multipleTable" v-if="isTableShow"  height="510">
          <el-table-column type="selection" :reserve-selection="true"></el-table-column>
          <el-table-column property="dataName" label="课件名称"></el-table-column>
          <el-table-column property="teacherName" label="教师名称"></el-table-column>
          <el-table-column
            label="行业类型">
            <template slot-scope="scope">
              <span v-if="scope.row.categoryName" v-html="scope.row.categoryName">
              </span>
                <span v-else>
                 --
              </span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          style="margin-top:20px; float:right;"
          @size-change="sizeChange"
          :current-page="page"
          @current-change="pageChange"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>

      </div>

      <batchBox title="选中课件" :props="batchBoxProps" @selection-change="batchBoxChange" ref="batchBox"></batchBox>

      <span slot="footer" style="text-align: center; margin-top: 30px" class="p10">
        <el-button @click="isShow = false">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import api from "@/api/mall/training";

import batchBox from '@/pages/mall/component/batchBox.vue';
import exam from "@/api/mall/exam.js";
import selectTree from "@/components/common/selectTree";
export default {
  name: "resourcesDataSelector",
  components: {batchBox,selectTree},

  data() {
    return {
      isShow: false,
      dataForm: {
        dataName:  undefined,
        professionalCategory: undefined,
        directoryId: undefined,
      },
      categoryList: [],
      dataList: [],
      catalogList: [],   //目录列表
      total: 0,
      pageSize: 10,
      page: 1,

      tableLoading: false,
      options: [],
      selectDataList: [],
      isTableShow: true,
      batchBoxProps: {
        value: 'id',      // ID字段名
        label: 'dataName',   // 显示名称
      }
    }
  },
  methods: {
    tableReload(){
      this.dataList = JSON.parse(JSON.stringify(this.dataList));
    },
    search(){
        this.page = 1;
        this.getDataList();
    },
    //获取资料列表
    getDataList() {
      let param = {
        page: this.page,
        pageSize: this.pageSize,
        isAble: 0,
        ...this.dataForm,
        // enterpriseId: JSON.parse(localStorage.getItem("userinfo")).enterpriseId
      };
      this.tableLoading  = true;
      api.getDataList(param).then(res => {
        let list = res.data.records;
        list.forEach(v => {
          if (this.categoryList && this.categoryList.length > 0) {
            this.categoryList.forEach(v2 => {
              if (v.professionalCategory == v2.code) {
                v.categoryName = v2.text;
              }
            });
          }
        });
        this.dataList = list;
        this.total = res.data.total;
        this.tableLoading  = false;
      });
    },
    pageChange(e) {
      this.page = e;
      this.getDataList();
    },
    sizeChange(e) {
      this.pageSize = e;
      this.search();
    },
    //重置表单
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    selectionChange(e) {
      this.selectDataList = e;
      this.$refs.batchBox.setSelection(e);
    },
    batchBoxChange(rows){
      if (this.selectDataList){
        this.$refs.multipleTable.clearSelection();
      }
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
        this.tableReload();
      }
    },
    setSelection(rows){
      this.$nextTick().then(() => {
        this.$refs.multipleTable.clearSelection();
        if (rows) {
          rows.forEach(row => {
            if (row.trainingResourcesDataId) {
              row.id = row.trainingResourcesDataId;
            }
            this.$refs.multipleTable.toggleRowSelection(row);
          });
          this.tableReload();
        }
      });
    },
    show(){
      this.isShow = true;
    },
    getRowKeys(row){
      return row.id;
    },
    confirm() {
      this.$emit("confirm", this.selectDataList);
      this.isShow = false;
    },
    getCatalogList() {
      exam.getCatalogList({
        type: 3,
        // enterpriseId: JSON.parse(localStorage.getItem("userinfo")).enterpriseId
      })
        .then(res => {
          this.catalogList = res.data;
        });
    },
    selectTreeChange(v) {
      this.dataForm.directoryId = v.id
    }
  },
  mounted() {
    this.categoryList = JSON.parse(localStorage.getItem("categoryList"));
    this.search();
    this.getCatalogList();
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/mall/component/resourcesDataSelector.vue